import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import DataAction from '../../data/actions';
import request from '../../utils/request';
import getPrettyError from '../../utils/getPrettyError';
import useProvider from '../../core/EcrionProvider/useProvider';
/**@type {import('../../page/Settings/Installation/types').MicroserviceInstallationServerStatusState} */

var DEFAULT_SERVER_INSTALLATION = {
  status: 'MISSING',
  steps: 1,
  stepIdx: 0,
  step: '',
  expectedDuration: 5000,
  stepProgress: undefined,
  redirect: null //callback: null, //used only on backend

};
/**@type {import('../../page/Settings/Installation/types').MicroserviceInstallationUserState} */

var DEFAULT_USER_INSTALLATION = {
  intention: null,
  intentionCompleted: false,
  initializing: true,
  error: null,
  errorDismissed: false
};
var DEFAULT_REFRESH_INTERVAL = 1000;
/**
 * @param {{ [installationUrl]: string; [onSuccess]: () => any} options
 * @returns {import('../../page/Settings/Installation/types').MicroserviceInstallationStatus}
 */

var useInstallation = function useInstallation(_ref) {
  var installationUrl = _ref.installationUrl,
      onSuccess = _ref.onSuccess;
  var ref = React.useRef(true);
  var provider = useProvider();

  var _React$useState = React.useState(DEFAULT_USER_INSTALLATION),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      userState = _React$useState2[0],
      setUserState = _React$useState2[1];

  var _React$useState3 = React.useState(DEFAULT_SERVER_INSTALLATION),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      serverState = _React$useState4[0],
      setServerState = _React$useState4[1];

  var _React$useState5 = React.useState(0),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      stepProgress = _React$useState6[0],
      setProgress = _React$useState6[1];

  React.useEffect(function () {
    if (serverState.status !== 'INSTALLING' && serverState.status !== 'UNINSTALLING') return;
    var RESOLUTION = 500;
    var duration = serverState.expectedDuration || 5000;

    function progress() {
      setProgress(function (prevCompleted) {
        if (prevCompleted >= 100) return 100;
        var slow = 1;
        if (prevCompleted > 90) slow = 100;else if (prevCompleted > 80) slow = 10;else if (prevCompleted > 50) slow = 3;else if (prevCompleted > 30) slow = 2;
        return prevCompleted + 100 / slow / (duration / RESOLUTION);
      });
    }

    var timer = setInterval(progress, RESOLUTION);
    return function () {
      clearInterval(timer);
      setProgress(0);
    };
  }, [serverState.stepIdx, serverState.status, serverState.expectedDuration]);
  var actions = {};

  actions.install = function () {
    setUserState({
      intention: 'INSTALL'
    });
    return request({
      useMicroserviceBackend: true,
      url: installationUrl,
      method: 'POST',
      contentType: 'json'
    }).then(function (res) {
      setUserState({
        intention: 'INSTALL',
        intentionCompleted: true
      });
      return ref.current && fetchData();
    }).catch(function (err) {
      setUserState({
        intention: 'INSTALL',
        error: {
          title: 'Install error',
          details: getPrettyError(err)
        }
      });
      return ref.current && fetchData();
    });
  };

  actions.uninstall = function () {
    setUserState({
      intention: 'UNINSTALL'
    });
    return request({
      useMicroserviceBackend: true,
      url: installationUrl,
      method: 'DELETE',
      contentType: 'json'
    }).then(function (res) {
      setUserState({
        intention: 'UNINSTALL',
        intentionCompleted: true
      });
      return ref.current && fetchData();
    }).catch(function (err) {
      setUserState({
        intention: 'UNINSTALL',
        error: {
          title: 'Uninstall error',
          details: getPrettyError(err)
        }
      });
      return ref.current && fetchData();
    });
  };

  actions.resetToDefault = function (data) {
    setUserState({
      intention: 'RESET',
      error: null,
      errorDismissed: false
    });
    setServerState({
      status: 'RESTARTING'
    });
    return request({
      useMicroserviceBackend: true,
      url: installationUrl + '/reset',
      method: 'POST',
      contentType: 'json',
      data: data
    }).then(function (res) {
      setUserState({
        intention: 'RESET',
        intentionCompleted: true
      });
      return ref.current && fetchData();
    }).catch(function (err) {
      setUserState({
        intention: 'RESET',
        error: {
          title: 'Reset error',
          details: getPrettyError(err)
        }
      });
      return ref.current && fetchData();
    });
  };

  actions.dismissError = function () {
    return setUserState(function (state) {
      return _objectSpread({}, state, {
        errorDismissed: true
      });
    });
  };

  actions.dismissIntention = function () {
    setUserState(function (state) {
      return _objectSpread({}, state, {
        intentionCompleted: false
      });
    });
    if (onSuccess) onSuccess();

    if (provider && provider.routes && provider.routes.history) {
      var history = provider.routes.history;
      if (serverState.status === 'INSTALLED') if (history.replace) history.replace('/');
    }
  };

  var fetchData =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var action, payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return DataAction.item({
                dataType: 'microserviceSetting',
                id: 'installation'
              }).fetch();

            case 2:
              action = _context.sent;

              if (ref.current) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              setUserState(function (userState) {
                var failed = {};

                if (action.failed) {
                  failed.error = {
                    title: 'Initialize installation error',
                    details: getPrettyError(action.payload)
                  };
                }

                return _objectSpread({}, userState, failed, {
                  initializing: false
                });
              });

              if (!action.failed) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              if (action.payload) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", setServerState({
                status: 'MISSING'
              }));

            case 10:
              if (!action.payload) {
                _context.next = 13;
                break;
              }

              payload = JSON.parse(action.payload);
              return _context.abrupt("return", setServerState(payload));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var refreshTimer = null;
  React.useEffect(function () {
    var addTimeout = function addTimeout() {
      clearTimeout(refreshTimer);
      if (!ref.current) return;
      refreshTimer = setTimeout(function () {
        fetchData().then(addTimeout);
      }, DEFAULT_REFRESH_INTERVAL);
    };

    fetchData().then(addTimeout);
    return function () {
      clearTimeout(refreshTimer);
      ref.current = false;
    };
  }, []);
  return {
    userState: userState,
    serverState: serverState,
    progress: serverState.stepIdx * (100 / serverState.steps) + stepProgress / serverState.steps,
    actions: actions
  };
};

export default useInstallation;